import * as React from 'react';

import { BaseNotification } from '../../notifications-data-instances';
import { BaseNotificationComponent, INotificationElementProps } from './base-notification-component';

/**
 * Represents the component which composes the body of a notification
 */
export class NotificationContent<NotificationType extends BaseNotification> extends BaseNotificationComponent<NotificationType, INotificationElementProps<NotificationType>> {
    /**
     * The class for the styles.
     */
    public static readonly className: string = 'msc-notification-content';

    public constructor(props: INotificationElementProps<NotificationType>) {
        super(props);
    }

    public render(): React.ReactNode {
        return (
            <div className={NotificationContent.className}>
                {this.props.children}
            </div>
        );
    }
}